import { render, staticRenderFns } from "./AtomImage.vue?vue&type=template&id=f495bca2&scoped=true&"
import script from "./AtomImage.vue?vue&type=script&lang=ts&"
export * from "./AtomImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f495bca2",
  null
  
)

export default component.exports